import { EndPoints } from "../../Constants/endpoints";
import { useGetData } from "../../hooks";
import { GetArticles } from "../../interface/GeneralResponse";
import { ArticleLoader, TitleWithArrow } from "../../Share";
import { InspectedArticleCard } from "./component";

const Articles = () => {
  const { data, isPending } = useGetData<GetArticles[]>(
    EndPoints.GetAllArticles,
  );
  return (
    <div className="box h-full overflow-y-auto">
      <TitleWithArrow title="articles" />
      {isPending ? (
        <ArticleLoader length={6} />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {data?.Data?.map((item, i) => (
            <InspectedArticleCard key={i} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Articles;
